import React, { useState } from "react";
import { Dropdown, Button, message, Modal } from "antd";
import styles from "../../../styles/Components/new-insight/signals-section/StrategyDropdown.module.css";
import { IoIosArrowDown } from "react-icons/io";
import { HiPencil, HiTrash } from "react-icons/hi";
import {
  deleteStrategy,
  getStrategySignal,
  presentStrategyPack,
  setCurrentStrategy,
} from "../../../redux/new-insight/actions";
import { useDispatch, useSelector } from "react-redux";
import CreateStrategyModal from "../create-strategy/CreateStrategyModal";
import EditStrategyModal from "./EditStrategyModal";
import { useSearchParams } from "react-router-dom";
import { MdOutlineFilterAlt } from "react-icons/md";
import { getRelativeTime } from "../../../utility/formatter-helper";

function packFeaturesKey(item) {
  const raw = item?.list_feature_info;
  try {
    const features = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!Array.isArray(features)) return item?.createdDate || "";
    return features
      .map((feature) =>
        [feature?.category, feature?.subcategory, feature?.feature]
          .filter(Boolean)
          .join("/"),
      )
      .sort()
      .join("|");
  } catch (err) {
    return item?.createdDate || "";
  }
}

function canBeTreatedAsArray(input) {
  const str = String(input ?? "");
  return str.includes("[") && str.includes("]");
}

const StrategyDropdown = ({ data, title, loading, type, icon }) => {
  const {
    main: { userData },
    newInsightState: { insightMarketType },
  } = useSelector((state) => state);
  const [showFeaturesModal, setShowFeaturesModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [open, setOpen] = useState(false);
  // TARGET STRATEGY TO EDITION
  const [selectedStrategy, setSelectedStrategy] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  // const [filteredData, setFilteredData] = useState(data);
  const [selectedTag, setSelectedTag] = useState("");

  const market = insightMarketType || "crypto";
  const marketData = (data || []).filter(
    (item) => (item.market_type || "crypto") === market,
  );
  const seenFeatures = new Set();
  const uniqueMarketData =
    type === "system"
      ? marketData.filter((item) => {
          const signature = packFeaturesKey(item);
          if (seenFeatures.has(signature)) return false;
          seenFeatures.add(signature);
          return true;
        })
      : marketData;
  const filteredData =
    type !== "system" && selectedTag
      ? uniqueMarketData.filter((item) => item.strategy_tag === selectedTag)
      : uniqueMarketData;

  const sortedFilteredData = filteredData.slice().sort((a, b) => {
    const aT = a?.createdDate ? new Date(a.createdDate).getTime() : 0;
    const bT = b?.createdDate ? new Date(b.createdDate).getTime() : 0;
    if (!Number.isNaN(aT) && !Number.isNaN(bT)) return bT - aT;
    return String(b?.createdDate || "").localeCompare(
      String(a?.createdDate || ""),
    );
  });

  const dispatch = useDispatch();

  const confirmToDeleteStrategy = (date) => {
    setOpen(false);
    Modal.confirm({
      title: "Warning",
      centered: true,
      content: "Are you sure you want to delete this strategy?",
      okText: "Yes, I am",
      okButtonProps: {
        style: {
          backgroundColor: "#0c3fce",
          borderColor: "#0c3fce",
        },
      },
      onOk: async () => {
        await dispatch(
          deleteStrategy(
            userData["custom:custom_username"],
            userData?.email,
            date,
          ),
        );
        Modal.destroyAll();
      },
      onCancel: () => {
        Modal.destroyAll();
      },
    });
  };

  const handleEditStrategy = (e, data) => {
    const {
      strategy_label,
      strategy_tag,
      strategy_name,
      list_feature_info,
      createdDate,
    } = data;
    e.stopPropagation();

    setSelectedStrategy({
      strategyTag: strategy_tag,
      strategyName: strategy_name,
      strategyLabel: strategy_label,
      strategyInfo: { strategy_label, strategy_tag, strategy_name },
      strategyList: [...JSON.parse(list_feature_info)],
      strategyId: createdDate,
    });

    setOpen(false);
    setShowEditModal(true);
    // TODO: UNCOMMENT IT
    // setSelectedStrategy(data);
  };

  const getSignals = (date, item) => {
    setSearchParams({});

    // Store strategy data in the URL
    searchParams.set("strategy", date);
    setSearchParams(searchParams);
    dispatch(setCurrentStrategy(item));

    dispatch(
      getStrategySignal(
        userData["custom:custom_username"],
        userData?.email,
        date,
        type === "system",
        false,
        insightMarketType || "crypto",
      ),
    );
  };

  const handleTagClick = (e, tag) => {
    e.stopPropagation();
    setSelectedTag(tag === "All" ? "" : tag);
  };

  const uniqueTags = [
    "All",
    ...new Set(marketData.map((item) => item.strategy_tag).filter(Boolean)),
  ];

  const submenuItems = uniqueTags.map((tag) => ({
    key: tag === "All" ? "" : tag,
    label: (
      <span
        style={{ display: "block" }}
        className={styles.strategyName}
        onClick={(e) => handleTagClick(e, tag)}
      >
        {tag}
      </span>
    ),
  }));

  const items = [
    // ...(type !== "system"
    //   ? [
    //       {
    //         key: "filter",
    //         label: (
    //           <span style={{ display: "flex", alignItems: "center" }}>
    //             <MdOutlineFilterAlt size={16} /> Filter by Tag
    //           </span>
    //         ),
    //         children: submenuItems,
    //       },
    //     ]
    //   : []),
    ...sortedFilteredData.map((item, index) => {
      const { name, label, tag, description } = presentStrategyPack(item);
      const { createdDate: date, list_feature_info: features } = item;

      const featuresNum = JSON.parse(features)?.length;

      return {
        key: `${date}-${index}-${name}`,
        label: (
          <div
            className={styles.strategyItem}
            onClick={() => getSignals(date, item)}
          >
            <div className={styles.strategyInfo}>
              <div className={styles.infoBox}>
                <span className={styles.infoTitle}>Name:</span>
                <span className={styles.strategyName}>{name}</span>
              </div>
              {Number.isFinite(Number(item?.goodness)) ? (
                <div className={styles.infoBox}>
                  <span className={styles.infoTitle}>Goodness:</span>
                  <span className={styles.strategyName}>
                    {Math.round(Number(item.goodness))}%
                  </span>
                </div>
              ) : null}
              {description ? (
                <div className={styles.usefulness}>{description}</div>
              ) : null}
              <div className={styles.infoBox}>
                <span className={styles.infoTitle}>Number of Features:</span>
                <span className={styles.strategyName}>{featuresNum}</span>
              </div>
              <div className={styles.infoBox}>
                <span className={styles.infoTitle}>Created Date:</span>
                <span className={styles.strategyName}>
                  {getRelativeTime(date)}
                </span>
              </div>
              <div className={styles.infoBox}>
                <span className={styles.infoTitle}>Label:</span>
                {typeof label !== "object" ? (
                  canBeTreatedAsArray(label) ? (
                    JSON.parse(label).length > 0 ? (
                      JSON.parse(label)?.map((l, index) => (
                        <span
                          key={`${l + "-" + index}`}
                          className={styles.label}
                        >
                          {l === "[]" ? "-" : l}
                        </span>
                      ))
                    ) : (
                      <span key={index} className={styles.label}>
                        -
                      </span>
                    )
                  ) : (
                    <span key={index} className={styles.label}>
                      {label}
                    </span>
                  )
                ) : label?.length > 0 ? (
                  label?.map((item, index) => (
                    <span key={index} className={styles.label}>
                      {label}
                    </span>
                  ))
                ) : (
                  "-"
                )}
                {/*<span className={styles.label}>{label}</span>*/}
              </div>
              <div className={styles.infoBox} style={{ flexWrap: "wrap" }}>
                <span className={styles.infoTitle}>Tag:</span>
                {tag?.length > 0
                  ? tag?.map((item, index) => (
                      <span key={index} className={styles.tag}>
                        {item}
                      </span>
                    ))
                  : "-"}
                {/*<span className={styles.tag}>{tag}</span>*/}
              </div>
            </div>
            {type === "user" && (
              <div className={styles.strategyHandlers}>
                <span onClick={(e) => handleEditStrategy(e, item)}>
                  <HiPencil size={14} />
                </span>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    confirmToDeleteStrategy(item.createdDate);
                  }}
                >
                  <HiTrash size={14} />
                </span>
              </div>
            )}
          </div>
        ),
      };
    }),
  ];

  const handleCreateClick = () => {
    message.destroy();
    setShowFeaturesModal(true);
  };

  const handleButtonClick = () => {
    if (type === "user" && data.length === 0) {
      message.info(
        <p style={{ marginBottom: 0 }}>
          No strategy available!{" "}
          <span
            style={{ color: "#0C4CFC", cursor: "pointer" }}
            onClick={handleCreateClick}
          >
            Create
          </span>{" "}
          the first one now.
        </p>,
      );
    }
  };

  return (
    <div className={styles.container}>
      {data.length > 0 ? (
        <Dropdown
          menu={{
            items,
          }}
          open={open}
          onOpenChange={setOpen}
          className={styles.dropdown}
          trigger="click"
          getPopupContainer={(trigger) => trigger.parentElement}
        >
          <Button
            className={`${styles.btn} 
            
            `}
          >
            {icon || ""}
            {title} <IoIosArrowDown />
          </Button>
        </Dropdown>
      ) : (
        <Button
          onClick={handleButtonClick}
          loading={loading}
          className={`${styles.btn}`}
        >
          {title} <IoIosArrowDown />
        </Button>
      )}

      {showFeaturesModal && (
        <CreateStrategyModal
          show={showFeaturesModal}
          closeHandler={() => setShowFeaturesModal(false)}
          type={"create"}
        />
      )}

      {showEditModal && (
        <EditStrategyModal
          setShow={setShowEditModal}
          show={showEditModal}
          data={selectedStrategy}
        />
      )}
    </div>
  );
};

export default StrategyDropdown;

// ${
//   type === "system" ? styles.systemBtn : styles.userBtn
// }
